import { observer } from 'mobx-react-lite';
import { Form, Select } from 'semantic-ui-react';
import { useStore } from '../../../../app/stores/store';
import {
  chartOptions,
  doughnutOptions,
  horizontalBarOptions,
  verticalBarOptions,
} from '../fixture';
import './styles.css';

function Chart() {
  // -------------------- Stores ------------------------ //
  const { DashboardConfigurationStore } = useStore();

  return (
    <>
      <div className="chart-config-wrapper" style={{ marginTop: '16px' }}>
        <h4>{'Chart'}</h4>
        <Form.Field
          className="chart-dropdown"
          control={Select}
          placeholder={'Select chart type'}
          clearable
          fluid
          // search
          selection
          options={chartOptions}
          onKeyDown={(e: { keyCode: string; stopPropagation: any }) => {
            if (e.keyCode === 'Backspace' || e.keyCode === 'Delete')
              e.stopPropagation();
          }}
          style={{ marginTop: '5px' }}
          value={DashboardConfigurationStore.chart.chartType}
          onChange={(_e: any, data: any) =>
            (DashboardConfigurationStore.chart.chartType = data.value)
          }
        />
      </div>
      <Form>
        <Form.Field
          control={Select}
          placeholder={'Select chart name'}
          clearable
          fluid
          search
          selection
          options={
            DashboardConfigurationStore.chart.chartType === 'doughnut'
              ? doughnutOptions
              : DashboardConfigurationStore.chart.chartType === 'verticalBar'
                ? verticalBarOptions
                : horizontalBarOptions
          }
          onKeyDown={(e: { keyCode: string; stopPropagation: any }) => {
            if (e.keyCode === 'Backspace' || e.keyCode === 'Delete')
              e.stopPropagation();
          }}
          style={{ marginTop: '5px' }}
          value={DashboardConfigurationStore.chart.chartName}
          onChange={(_e: any, data: any) =>
            (DashboardConfigurationStore.chart.chartName = data.value)
          }
        />
      </Form>
    </>
  );
}

export default observer(Chart);
